import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { EnrichedBulletList } from '../interactions/EnrichedBulletList.jsx'

/**
 * StuckCard — bulleted blockers with severity chip.
 * catalog #13, prep-stuck. Rename of prep-challenges.
 *
 * 'Surface' action (creates TalkingPoint via Phase F Pull edge) — deferred.
 * Phase E ships without the Surface button; Phase F wires the Pull mechanic.
 */
export function StuckCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasUnseverered = items.some((i) => i.text && !i.suffix)
  const hasBullets = items.some((i) => i.text)

  return (
    <CardFrame
      kind="prep"
      icon="▲"
      iconClass="rust"
      title="Stuck on"
      prompt="Where are you blocked right now?"
      state={disabled ? 'locked' : hasUnseverered ? 'error' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-stuck"
      className="prepcard"
    >
      <EnrichedBulletList
        items={items}
        onChange={onChange}
        suffixType="severity"
        maxItems={10}
        maxChars={140}
        placeholder="Something blocking you…"
        disabled={disabled}
      />
      {/* Phase E follow-up: Surface button → TalkingPoint via Phase F Pull edge */}
    </CardFrame>
  )
}
